<script lang="ts">
	import '@mux/mux-player'

	let { id, autoplay = false } = $props()
</script>

<mux-player disable-cookies="true" playback-id={id} accent-color="var(--c-rose)" {autoplay}></mux-player>

<style lang="css">
	mux-player {
		--media-font: var(--f-family);
		width: 92vw;

		@media (--from-mobile) {
			max-width: calc(var(--s-wrap) + 2rem);
			width: 90vw;
		}

		&::part(center play button) {
			background-color: var(--c-charcoal);
			box-shadow: none;
			stroke: white;
		}

		&::part(bottom seek-forward button),
		&::part(bottom seek-backward button) {
			scale: 1.2;
		}

		&::part(control-bar bottom)::before {
			background: var(--c-charcoal);
			padding: 3.5rem 0 0;
			opacity: 1;
		}
	}
</style>
